module.exports = __webpack_public_path__ + "static/media/teamThree.603af453.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Images/rowSix/team/teamThree.jpg
// module id = 98
// module chunks = 0